module.exports = __webpack_public_path__ + "static/media/Cooperationbg3@3x.836fd2ac.png";